import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import swal from 'sweetalert2';

@Component({
    selector: 'app-content-detail',
    templateUrl: './content-detail.component.html',
    styleUrls: ['./content-detail.component.scss'],
    standalone: false
})
export class ContentDetailComponent implements OnInit {

  @Output() close: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  submitted = false

  contentForm: UntypedFormGroup

  constructor(private fb: UntypedFormBuilder, private httpService: HttpService ) { }

  ngOnInit() {

    this.createContentForm()

  }

  get f() {
    return this.contentForm.controls
  }

  ngOnChanges(){
    this.createContentForm()
    this.rebuildForm()
  }

  rebuildForm(){

    this.contentForm.reset({
      google_doc_id: '',
    })

    this.submitted = false

  }

  onCancel(){
    this.close.emit(false)
  }

  async onSubmit(){
    const formModel = this.contentForm.value;
    this.submitted = true

    if( this.contentForm.invalid ){
      console.log('invalid')
      return
    }

    const doc = formModel.google_doc_id
    let id = ''

    if( doc && doc.length == 44 ){
      id = doc
    }
    if( doc && doc.length > 44 ){

      // match id
      id = doc.match(/\/[/\w\-_]{44}\//)
      if( !id ){
        this.close.emit(false)
        swal('Oops...', "Google Doc ID could not be extracted from the input.", 'error')
        return
      }
      id = id[0].substring(1,45)
    }
    console.log('have id: ', id)

    if( !id || id.length != 44 ){
      this.close.emit(false)
      swal('Oops...', "Google Doc ID could not be extracted from the input.", 'error')
      return
    }

    const save = {
      googleDocId: id,
    }


    const result :any = await this.httpService.postAsync( 'hcontent/newContent', save )

    console.log(result)
    if( !result.success && result.status == '404'){
      alert("Document not found")
    }

    if( result.error && result.message == "existing" ){
      alert("This document already exists and cannot be added again.")
    }



    this.close.emit(result.success)
  }


  createContentForm(){
    this.contentForm = this.fb.group({
      google_doc_id: ['', Validators.required],
    })
  }
}
